import { render, staticRenderFns } from "./clients-table.vue?vue&type=template&id=b9ca0e4c&"
import script from "./clients-table.vue?vue&type=script&lang=js&"
export * from "./clients-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports